import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  NavLink,
  Switch
} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Header,
  Dropdown,
  Image,
  Menu,
  Icon,
  Popup,
  Sidebar,
  Segment
} from 'semantic-ui-react';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import _ from 'lodash';
import TagManager from 'react-gtm-module';

import { fbInitSDK } from '../config/FBAdOps';
import * as AppActions from '../actions';
import * as Screens from '../screens';
import { PrivateRoute } from '../components';
import Images from '../assets/Images';
import { routes } from './menuOptions';
import domains, { getGTMIdByDomain } from './Domains';
import MenuComponent from '../components/common/MenuComponent';
import { getAccounts } from '../services/AccountService';
import { getLookerAccounts } from './../../src/services/InsightsPreviewManager';
import { api as apiBuilder } from '../utils/apiBuilder';

const { featureFlags } = domains || {};
const { useNewNavUi } = featureFlags || {};

const tokenQuery = {
  query: gql`
    query {
      token: tokenByName(name: "sysuser_write") {
        id
        name
        token
      }
    }
  `
};

class App extends Component {
  state = {
    sidebarActive: true,
    loaded: false,
    sectionTitle: '',
    token: null,
    isShareLinks: false,
    isIframeShareLinks: false,
    isImportShareLinks: false,
    activeOption: 'Dashboard',
    loginUrls: [
      '/',
      '/login',
      '/auth/login',
      '/auth/forgot_password',
      '/auth/reset_password',
      '/auth/activate_account'
    ],
    fbIsDown: false,
    fbErrorMessage: 'FB is down',
    showMenu: false
  };

  componentDidMount() {
    window._ = _;
    this.init();
    try {
      fbInitSDK();
    } catch (error) {
      console.log('Error with fbInitSDK(): ', error);
    }
    this.initializeTagManager();
    // this.getFBStatus();
  }

  initializeTagManager = () => {
    const gtmId = getGTMIdByDomain();
    const tagManagerArgs = {
      gtmId,
      dataLayerName: 'pageview'
    };

    TagManager.initialize(tagManagerArgs);
  };

  setSectionTitle = (sectionTitle) => {
    this.setState({ sectionTitle });
  };

  saveGTMEvent = (pageName, pageTitle) => {
    const tagManagerArgs = {
      dataLayer: {
        path: window.location.pathname + window.location.hash,
        title: pageTitle,
        name: pageName
      },
      dataLayerName: 'pageview'
    };

    TagManager.dataLayer(tagManagerArgs);
  };

  getFbToken = () => this.state.token;

  userLogged = () => {
    this.props.userLogged();
  };

  loadFbToken = async () => {
    const shareLinks = '/presentations/detail/';
    const importShareLinks = '/presentationsImport/detail/';
    const currentURL = window.location.href;
    const isShareLinks = currentURL.indexOf(shareLinks) !== -1;
    const isImportShareLinks = currentURL.indexOf(importShareLinks) !== -1;

    if (!this.state.token) {
      if (!isShareLinks && !isImportShareLinks) {
        try {
          await this.getToken(tokenQuery);
        } catch (ex) {
          this.props.refreshToken();
        }
      }
    }

    return this.state.token;
  };

  init = async () => {
    const shareLinks = '/presentations/detail/';
    const iframeShareLinks = '/insightsPreview/detail/';
    const importShareLinks = '/presentationsImport/detail/';
    const currentURL = window.location.href;
    const isShareLinks = currentURL.indexOf(shareLinks) !== -1;
    const isIframeShareLinks = currentURL.indexOf(iframeShareLinks) !== -1;
    const isImportShareLinks = currentURL.indexOf(importShareLinks) !== -1;

    if (this.props.user.loggedIn) {
      await this.loadFbToken();
      await this.loadCommonData();
    }

    this.setState({
      loaded: true,
      isShareLinks,
      isIframeShareLinks,
      isImportShareLinks
    });
  };

  loadCommonData = async () => {
    const { groups } = this.props.user;
    await getAccounts(groups[0]);

    const applyGuestFilter = ['NU'].includes(groups[0]);

    if (!applyGuestFilter) {
      await getLookerAccounts();
    }
  };

  getToken = async (queryToken) => {
    await this.props.client.query(queryToken).then((response) => {
      this.setState({ token: response.data.token.token });
    });
  };

  logout = (event) => {
    localStorage.setItem('tokenLastUpdate', null);
    event.preventDefault();
    const { actions } = this.props;
    actions.logout();
  };

  retrieveTextBanner = () => {
    const currentURL = window.location.href;
    let textBanner = '';
    textBanner =
      currentURL.indexOf('alexia-dev.constellationagency.com') !== -1
        ? 'DEVELOPMENT'
        : textBanner;
    textBanner =
      currentURL.indexOf('alexia-stg.constellationagency.com') !== -1
        ? 'STAGING'
        : textBanner;

    return textBanner;
  };

  getFBStatus = async () => {
    const url = apiBuilder.buildApi('fbhealth');
    const result = await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    // health should be 1. if != 1 display the error message
    // need this log here because this will be hard to check later if FB has no error
    const { health, subject } = result;
    console.log('FB Health:', `${health},${subject}`);
    if (result.health !== 1) {
      this.setState({
        fbIsDown: true,
        fbErrorMessage: `Health: ${health} - ${subject}`
      });
    }
  };

  // eslint-disable-next-line consistent-return
  renderFBErr = () => {
    const { fbIsDown, fbErrorMessage } = this.state;
    if (fbIsDown) {
      return (
        <Popup
          content={fbErrorMessage}
          trigger={
            <Icon
              name="warning sign"
              color="yellow"
              size="large"
              data-content={fbErrorMessage}
              className="ui icon"
            />
          }
        />
      );
    }
  };

  renderNav = () => {
    const { user } = this.props;
    const { showMenu, sectionTitle } = this.state;
    const textBanner = this.retrieveTextBanner();

    const navContent = useNewNavUi ? (
      <div className="App-nav">
        {textBanner ? <div className="env-banner">{textBanner}</div> : null}
        <Menu className="main-menu" size="large" fluid secondary>
          <Menu.Item
            id="hamburger-menu"
            name="Menu"
            active={!!showMenu}
            onClick={this.toggleNavMenu}
          >
            <Icon inverted size="big" name="bars" />
          </Menu.Item>
          <Menu.Item
            id="header-logo"
            style={useNewNavUi ? { paddingLeft: 0, marginRight: 'auto' } : {}}
            as={NavLink}
            exact
            to="/"
            activeClassName="dashboard-active"
          >
            <Image
              src={Images.alexiaLogoWhite}
              className="App-menu-logo"
              alt="logo"
              verticalAlign="middle"
            />
            {this.renderFBErr()}
          </Menu.Item>
          <Menu.Item className="title-container-nav">
            <Header as="h3" className="color-text-nav">
              {sectionTitle}
            </Header>
          </Menu.Item>
          <Dropdown
            id="header-user-email"
            item
            className="color-text-nav"
            text={user.email}
          >
            <Dropdown.Menu className="user-select">
              <Dropdown.Item onClick={this.logout}>
                <span className="user-select-text">Sign out</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
      </div>
    ) : (
      <div className="App-nav">
        <Menu
          className="main-menu"
          size="large"
          fluid
          pointing
          secondary
          doubling="true"
        >
          <Menu.Item
            as={NavLink}
            exact
            to="/"
            activeClassName="dashboard-active"
          >
            <Image
              src={Images.alexiaLogoWhite}
              className="App-menu-logo"
              alt="logo"
              verticalAlign="middle"
            />
            {this.renderFBErr()}
          </Menu.Item>
          <Menu.Item className="title-container-nav-old">
            <Header as="h3" className="color-text-nav-old">
              {sectionTitle}
            </Header>
          </Menu.Item>
          <Menu.Menu position="right">
            <Dropdown className="color-text-nav" item text={user.email}>
              <Dropdown.Menu className="user-select">
                <Dropdown.Item onClick={this.logout}>
                  <span className="user-select-text">Sign out</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        </Menu>
        {textBanner ? <div className="env-banner">{textBanner}</div> : null}
      </div>
    );

    return user.loggedIn && navContent;
  };

  getBannerWidth = () => {
    const sidebar = document.getElementById('app-sidebar-content');
    let envBannerWidth;
    if (sidebar) {
      const sidebarWidth = sidebar.clientWidth || 0;
      const appWindow = document.querySelector('.App-win');
      if (appWindow) {
        const windowWidth = appWindow.clientWidth || 0;
        envBannerWidth = windowWidth - sidebarWidth;
      }
    }
    return envBannerWidth;
  };

  toggleNavMenu = (passedBool) => {
    const { showMenu } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      showMenu: passedBool !== undefined ? passedBool : !showMenu
    }));
  };

  renderSidebar = () => {
    const { showMenu } = this.state;
    const { user } = this.props;
    const group = user.groups && user.groups.length > 0 ? user.groups[0] : null;
    const textBanner = this.retrieveTextBanner();
    let className = !textBanner
      ? 'App-sidebar-old'
      : 'App-sidebar-old sidebar-with-banner-old';

    if (useNewNavUi) {
      className = !textBanner
        ? 'App-sidebar'
        : 'App-sidebar sidebar-with-banner';
    }

    return user.loggedIn ? (
      <div className={className}>
        <MenuComponent
          user={user}
          group={group}
          showMenu={showMenu}
          toggleNavMenu={this.toggleNavMenu}
        />
      </div>
    ) : null;
  };

  renderPrivate = (route) => {
    const { user } = this.props;
    const group = user.groups && user.groups.length > 0 ? user.groups[0] : null;
    if (user.loggedIn && !group) {
      return null;
    }

    const denied = route.deniedGroups.find(
      (deniedGroup) => deniedGroup === group
    );
    return !denied ? (
      <PrivateRoute
        exact
        key={route.url}
        path={route.url}
        component={route.component}
        user={user}
        setSectionTitle={this.setSectionTitle}
        saveGTMEvent={this.saveGTMEvent}
        getFbToken={this.getFbToken}
      />
    ) : null;
  };

  renderContent = () => (
    <div
      className="App-content"
      style={
        !this.props.user || !this.props.user.loggedIn
          ? { left: 0 }
          : { left: useNewNavUi ? '0px' : '140px' }
      }
    >
      <Route
        path="/login"
        render={(props) => (
          <Screens.Login {...props} userLogged={this.userLogged} />
        )}
      />
      <Route
        path="/auth/login"
        render={(props) => (
          <Screens.Login {...props} userLogged={this.userLogged} />
        )}
      />
      <Route
        path="/auth/forgot_password"
        render={(props) => (
          <Screens.Login {...props} userLogged={this.userLogged} />
        )}
      />
      <Route
        path="/auth/reset_password"
        render={(props) => (
          <Screens.Login {...props} userLogged={this.userLogged} />
        )}
      />
      <Route
        path="/auth/activate_account"
        render={(props) => (
          <Screens.Login {...props} userLogged={this.userLogged} />
        )}
      />
      <Switch>
        {routes.map((route) =>
          route.isPrivate ? (
            this.renderPrivate(route)
          ) : (
            <Route
              key={route.url}
              path={route.url}
              component={route.component}
            />
          )
        )}
      </Switch>
    </div>
  );

  renderPatentPendingLogo = () => {
    const {
      sidebarActive,
      isShareLinks,
      isIframeShareLinks,
      isImportShareLinks
    } = this.state;

    const logoContent = (
      <div className="logo-patent-pending">
        <Image
          src={Images.patentPending}
          className="App-patent-pending"
          alt="patentPending"
          size="small"
        />
      </div>
    );

    return sidebarActive &&
      !isShareLinks &&
      !isIframeShareLinks &&
      !isImportShareLinks
      ? logoContent
      : null;
  };

  render() {
    const { user } = this.props;
    const { loginUrls, loaded, sidebarActive, showMenu } = this.state;
    const currentURL = window.location.pathname;
    const isLogin = loginUrls.find((url) => url === currentURL);

    const mainContenet = useNewNavUi ? (
      <Router>
        <div
          className={`${!user.loggedIn && isLogin ? 'App-login' : 'App-win'} ${
            user.loggedIn ? 'logged-in' : ''
          } ${sidebarActive ? 'sidebar-active' : ''}`}
        >
          {this.renderNav()}
          <div className="App-main">
            <Sidebar.Pushable as={Segment} basic>
              {this.renderSidebar()}
              <Sidebar.Pusher dimmed={!!showMenu}>
                {this.renderContent()}
                {this.renderPatentPendingLogo()}
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </div>
        </div>
      </Router>
    ) : (
      <Router>
        <div
          className={`${!user.loggedIn && isLogin ? 'App-login' : 'App-win'} ${
            user.loggedIn ? 'logged-in' : ''
          } ${sidebarActive ? 'sidebar-active-old' : ''}`}
        >
          {this.renderNav()}
          <div className="App-main">
            {this.renderSidebar()}
            {this.renderPatentPendingLogo()}
            {this.renderContent()}
          </div>
        </div>
      </Router>
    );

    return loaded ? mainContenet : null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  fbuser: state.fbuser
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js